/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useCallback} from "react";

export const useAutoCompleteOptionsFilterCallback = (primaryKeyField, invalidOptions, additionalFilter = null) => {
    
    return useCallback((autoCompleteItems, selectedModel) => {
        
        const selectedId = selectedModel ? selectedModel?.[primaryKeyField] : null;
        const excludedIds = invalidOptions?.map(x => Number(x?.[primaryKeyField])) ?? [];
        
        return autoCompleteItems.filter(x => {
            
            if (selectedId && Number(selectedId) === Number(x[primaryKeyField])) {
                // if this is the selected model, include it for display purposes
                return true;
            }
            
            if (excludedIds.includes(x?.[primaryKeyField])) {
                // if this item is already selected, filter it out
                return false;
            }
            
            if (additionalFilter) {
                // if there are additional filters, apply them
                return additionalFilter(x);
            }
            
            return true;
        });
    }, [primaryKeyField, invalidOptions, additionalFilter]);
}
